import { useLegacyDialogProps } from 'components/DialogV3/DialogManagerContext';
import { Button, DialogActions, DialogContent, DialogContentText, IconButton } from '@mui/material';
import apiManagerSystem from 'api/manager-systems';
import { IconClose } from 'assets/icons';
import TextFieldVMP from 'components/common/TextField/TextFieldVMP';
import { TOAST_DEFAULT } from 'constants/toast';
import { Form, Formik } from 'formik';
import { useRef } from 'react';
import { useTranslation } from 'react-i18next';
import { setCloseDialogCC, toastError, toastSuccess } from 'utils/helpers';
import * as yup from "yup";
import DialogBaseCC from './DialogBaseCC';
import { DIALOG_ID } from './constant';


const DialogAddConfig = () => {
    const propsDialog = useLegacyDialogProps();
    const { onSubmit } = propsDialog

    const { t } = useTranslation()
    const formRef = useRef();

    const validationSchema = yup.object({
        value: yup.string().required(t('config.notification.empty')),
        code: yup
            .string()
            .required(t('config.code_noti.empty'))
            .matches(/^[a-zA-Z0-9_]+$/, t('config.code_noti.special')),
    });

    const onConfirm = () => {
        if(formRef.current.isValid) {
            const { code, value, description } = formRef.current.values

            apiManagerSystem.createConfig({
                code: code,
                value: value,
                description: description ? description : '',
            })
                .then((res) => {
                    if (res.status === 200) {
                        toastSuccess(t('subTabHistorySystem.toast.createSuccess'));
                        if(onSubmit){
                            onSubmit();
                        }
                        setCloseDialogCC()
                    } else {
                        toastError(t('subTabHistorySystem.toast.createError'));
                    }
                })
                .catch((error) => {
                    toastError(TOAST_DEFAULT.ERROR);
                });
        }
    }

    return (
        <DialogBaseCC id={DIALOG_ID.ADD_CONFIG} title={t('config.title')}>
            <DialogContent>
                <DialogContentText>
                <Formik
                innerRef={formRef}
                enableReinitialize
                initialValues={{
                    value: '',
                    code: '',
                    description: '',
                }}
                validationSchema={validationSchema}
                onSubmit={onConfirm}
            >{props => {
                const {
                    values,
                    touched,
                    errors,
                    handleChange,
                    setFieldValue,
                    handleSubmit
                } = props;
                return (
                    <Form onSubmit={handleSubmit}>
                        <div className={'form-input'}>
                            <div className={'label'}>{t('config.code')}<span className={'required'}>*</span></div>
                            <TextFieldVMP
                                autoFocus={true}
                                shrink="true"
                                fullWidth
                                id="code"
                                name="code"
                                value={values.code}
                                onChange={handleChange}
                                error={touched.code && Boolean(errors.code)}
                                helperText={touched.code && errors.code}
                                size="small"
                                InputProps={
                                    values.code === '' ?
                                        {
                                        } :
                                        {
                                            endAdornment: (
                                                <IconButton
                                                    aria-label="toggle password visibility"
                                                    onClick={() => setFieldValue('code', '')}
                                                    sx={{ p: 0.5 }}
                                                ><IconClose /></IconButton>
                                            )
                                        }
                                }
                            />
                        </div>
                        <div className={'form-input'}>
                            <div className={'label'}>{t('config.value')}<span className={'required'}>*</span></div>
                            <TextFieldVMP
                                shrink="true"
                                fullWidth
                                id="value"
                                name="value"
                                value={values.value}
                                onChange={handleChange}
                                error={touched.value && Boolean(errors.value)}
                                helperText={touched.value && errors.value}
                                size="small"
                                InputProps={
                                    values.value === '' ?
                                        {
                                        } :
                                        {
                                            endAdornment: (
                                                <IconButton
                                                    className={""}
                                                    aria-label="toggle password visibility"
                                                    onClick={() => setFieldValue('value', '')}
                                                    sx={{ p: 0.5 }}
                                                ><IconClose /></IconButton>
                                            )
                                        }
                                }
                            />
                        </div>
                        <div className={'form-input'}>
                            <div className={'label'}>{t('config.description')}</div>
                            <TextFieldVMP
                                // shrink="true"
                                fullWidth
                                id="description"
                                name="description"
                                value={values.description}
                                onChange={handleChange}
                                error={touched.description && Boolean(errors.description)}
                                helperText={touched.description && errors.description}
                                size="small"
                                multiline
                                InputProps={
                                    values.description === '' ?
                                        {
                                        } :
                                        {
                                            endAdornment: (
                                                <IconButton
                                                    aria-label="toggle password visibility"
                                                    onClick={() => setFieldValue('description', '')}
                                                ><IconClose /></IconButton>
                                            )
                                        }
                                }
                            />
                        </div>
                    </Form>
                )
            }}
            </Formik>
                </DialogContentText>
            </DialogContent>
            <DialogActions>
                <Button variant='outlined' onClick={setCloseDialogCC}>{t('dialog.cancel')}</Button>
                <Button type='submit' onClick={() => {formRef.current.handleSubmit()}} >{t('actions.saveConfig')}</Button>
            </DialogActions>
        </DialogBaseCC>
    )
}

export default DialogAddConfig